// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"67":"597207ec","105":"b45acb52","292":"7040b2ef","370":"69a6f58f","417":"3aa3adc7","810":"96cb67dc"}[chunkId] + ".chunk.js";
};